import { localize } from 'helpers/translator'

export const sortOptions = [
	{
		value: 'date',
		type: 'desc',
		text: localize('global_lessons_sort_recent'),
	},
	{
		value: 'name',
		type: 'asc',
		text: localize('sort_options_name'),
	},
	{
		value: 'author',
		type: 'asc',
		text: localize('sort_options_author'),
	},
	{
		value: 'size',
		type: 'desc',
		text: localize('sort_options_size'),
	},
]
